import script from "./InquiryPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./InquiryPage.vue?vue&type=script&setup=true&lang=ts"

import "./InquiryPage.vue?vue&type=style&index=0&id=2f6af19b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f6af19b"]])

export default __exports__